module.exports = __webpack_public_path__ + "static/img/loginindex1.0da93d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/loginindex1.png
// module id = 348
// module chunks = 0